"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPhoneAuthCallReEnterButtonClick = trackPhoneAuthCallReEnterButtonClick;
exports.trackPhoneAuthCallShow = trackPhoneAuthCallShow;
exports.trackPhoneAuthCallValidationFail = trackPhoneAuthCallValidationFail;
exports.trackPhoneAuthExhausted = trackPhoneAuthExhausted;
exports.trackPhoneAuthNeedHelp = trackPhoneAuthNeedHelp;
exports.trackPhoneAuthResendCodeClick = trackPhoneAuthResendCodeClick;
exports.trackPhoneAuthResendValidationCode = trackPhoneAuthResendValidationCode;
exports.trackPhoneAuthResumeButtonClick = trackPhoneAuthResumeButtonClick;
exports.trackPhoneAuthSmsValidationFail = trackPhoneAuthSmsValidationFail;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _tracking = require("../../utils/tracking");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * СОБЫТИЯ ФЛОУ АВТОРИЗАЦИИ ПО ТЕЛЕФОНУ
 */

/**
 * Клик по ссылке отправить еще раз
 */
function trackPhoneAuthResendValidationCode(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_send_again'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на "Мне не позвонили" при авторизации/регистрации через последние 4 цифры телефона
 */
function trackPhoneAuthResendCodeClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_resend_code',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Введен неверный код подтверждения, полученный по СМС
 */
function trackPhoneAuthSmsValidationFail(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Введен неверный код подтверждения, полученный по телефонному звонку
 */
function trackPhoneAuthCallValidationFail(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Введен неверный код, превышено кол-во попыток
 */
function trackPhoneAuthExhausted(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_fatal'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик по кнопке продолжить, после ввода телефона
 */
function trackPhoneAuthResumeButtonClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_continue'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик по ссылке нужна помощь
 */
function trackPhoneAuthNeedHelp(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_cant_confirm'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Показ экрана с запросом на ввод 4 последних цифр номера телефона
 */
function trackPhoneAuthCallShow(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Open',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на "Ввести заново" при авторизации/регистрации через звонок
 * Кнопка появляется в результате некорректной отправки кода
 */
function trackPhoneAuthCallReEnterButtonClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_re_enter_phone_code',
    label: 'last_phone_numbers'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}